import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { CompaniesService } from 'src/app/modules/companies/_services/companies.service';
import { ContractsService } from 'src/app/modules/companies/_services/contracts.service';
import { ServiceTypeCompany } from '../../_types/services-types-companies';
import { ServicesTypesCompaniesService } from '../../_services/services-types-companies.service';
import { InsuranceCompaniesService } from 'src/app/modules/insurance-companies/_services/insurance-companies.service';

@Component({
    selector: 'app-services-types-company',
    templateUrl: './services-types-company.component.html',
    styleUrls: ['./services-types-company.component.scss'],
    standalone: false
})
export class ServiceTypeCompanyComponent {

  public serviceTypeCompanyFormGroup!: RxFormGroup;
  public serviceTypeCompany: ServiceTypeCompany = new ServiceTypeCompany();
  public companies: any[] = [];
  public contracts: any[] = [];
  public insuranceCompanies: any[] = [];  
  public selectedContracts: any[] = [];
  public selectedInsuranceCompanies: any[] = [];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private servicesTypesCompaniesService: ServicesTypesCompaniesService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private companiesService: CompaniesService,
    private contractsService: ContractsService,
    private insuranceCompaniesService: InsuranceCompaniesService
  ) {
    this.serviceTypeCompanyFormGroup = this.formBuilder.formGroup<ServiceTypeCompany>(this.serviceTypeCompany) as RxFormGroup;
  }

  ngOnInit(): void {
    if (this.config.data.serviceTypeCompanyId) {
      this.loadServiceTypeCompany(this.config.data.serviceTypeCompanyId);
    } else {
      this.serviceTypeCompany.serviceTypeId = this.config.data.serviceTypeId;
    }
    this.loadCompanies();
    this.allowWrite = true;
    this.allowDelete = true;
  }

  async loadServiceTypeCompany(id: string) {
    this.serviceTypeCompany = await firstValueFrom(this.servicesTypesCompaniesService.get(id));            
    this.serviceTypeCompanyFormGroup.patchValue(this.serviceTypeCompany);

    this.loadContracts();    
  }

  async loadCompanies() {
    let response = await firstValueFrom(this.companiesService.all());
    this.companies = response.data;
  }

  async loadContracts() {
    let filters = {
      companyId: new Filter(FilterOperation.equals, 'companyId', "", this.serviceTypeCompanyFormGroup.value.companyId)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractsService.all(params));
    this.contracts = response.data;    
  }


  async loadInsuranceCompanies() {    
    let response = await firstValueFrom(this.insuranceCompaniesService.all());
    this.insuranceCompanies = response.data;    
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.serviceTypeCompanyFormGroup);
    if (valid) {
      this.serviceTypeCompany = Object.assign(this.serviceTypeCompany, this.serviceTypeCompanyFormGroup.value);

      const companyId = this.serviceTypeCompanyFormGroup.value.companyId;
      const contractIds = this.selectedContracts?.length ? this.selectedContracts : [null];
      const insuranceCompanyIds = this.selectedInsuranceCompanies?.length ? this.selectedInsuranceCompanies : [null];

      const requests = [];

      for (const contractId of contractIds) {
          for (const insuranceCompanyId of insuranceCompanyIds) {
              this.serviceTypeCompany.contractId = contractId;
            
              let serviceTypeCompany = await firstValueFrom(this.servicesTypesCompaniesService.save(this.serviceTypeCompany));
          }
      }
      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Compañía guardada correctamente." });
      this.dynamicDialogRef.close();

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea desasignar la compañía?",
      header: "Desasignar compañía",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.servicesTypesCompaniesService.delete(this.serviceTypeCompany.id).subscribe({
          next: () => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Compañía desasignada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }
}
